module.exports = __webpack_public_path__ + "img/logo-white.45bd8e5e.png";